import { request } from '@sh/services/axios';

export default {
  campaigns: {
    async bulkActions(type, value, campaigns) {
      return request.post('campaign-bulk-actions', { type, value, campaigns });
    },
    // ? Change Bid
    async changeCampaignBid(campaignId, bid, bidType, byCountry, setDefaultCountryBid) {
      return request.post(`/campaigns/${campaignId}/change-bid`, {
        bid, bidType, byCountry, setDefaultCountryBid,
      });
    },
    // ? Change Daily Budget
    async changeCampaignDailyBudget(campaignId, dailyBudget, dailyBudgetType) {
      return request.post(`campaigns/${campaignId}/change-daily-budget`, { dailyBudget, dailyBudgetType: dailyBudgetType || 'limited' });
    },
    // ? Change Total Budget
    async changeCampaignTotalBudget(campaignId, totalBudget, totalBudgetType) {
      return request.post('campaignTotalBudget', { campaignId, totalBudget, totalBudgetType: totalBudgetType || 'limited' });
    },
    async changePublisherBid(campaignId, publisherId, bid) {
      return request.post('publisherBid', { campaignId, publisherId, bid });
    },
    async changeSourceBid(campaignId, sourceId, bid) {
      return request.post('zpsource-bid', { campaignId, sourceId, bid });
    },
    async changeKeywordBid(campaignId, keywordId, bid) {
      return request.post('keyword-bid', { campaignId, keywordId, bid });
    },
    async changePublisherBidBulk(campaignId, publisherIds) {
      return request.post('publisher-bid-bulk', { campaignId, publisherIds });
    },
    async performanceChart(id, startDate, endDate, type) {
      const params = { type, startDate, endDate };
      return request.get(`campaigns/${id}/campaign-performance-chart`, { params });
    },
  },
  publishers: {
    async action(campaignId, publisherIds, action, listId) {
      const payload = { campaignId, publisherIds, action };
      if (listId) {
        payload.listId = listId;
      }
      return request.post('publisher-actions', payload);
    },
    async basicStats(startDate, endDate, campaignId) {
      return request.get('basic-stats', { params: { startDate, endDate, campaignId } });
    },
    async performance(id, params) {
      return request.get(`campaigns/${id}/publishers`, { params });
    },
  },
  sources: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/sources`, { params });
    },
    async action(campaignId, sourceIds, action) {
      const payload = { campaignId, sourceIds, action };
      return request.post('zpsource-actions', payload);
    },
  },
  channels: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/channels`, { params });
    },
    async action(campaignId, channelIds, action) {
      const payload = { campaignId, channelIds, action };
      return request.post('rtxchannel-actions', payload);
    },
  },
  creatives: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/creatives`, { params });
    },
    async action(campaignId, creativeIds, action) {
      const payload = { campaignId, creativeIds, action };
      return request.post('creative-actions', payload);
    },
  },
  domains: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/domains`, { params });
    },
    async action(campaignId, domainIds, action) {
      const payload = { campaignId, domainIds, action };
      return request.post('domain-actions', payload);
    },
  },
  subIds: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/subids`, { params });
    },
    async action(campaignId, subIds, action) {
      const payload = { campaignId, subIds, action };
      return request.post('subid-actions', payload);
    },
  },
  keywords: {
    async performance(id, params) {
      return request.get(`campaigns/${id}/keywords`, { params });
    },
    async action(campaignId, keywordIds, action) {
      const payload = { campaignId, keywordIds, action };
      return request.post('keyword-actions', payload);
    },
  },
  trackers: {
    async sources(id) {
      return request.get(`/trackers/${id}/getSources`);
    },
  },
  trafficSources: {
    async tokens(type) {
      return request.post('/traffic-sources/getTokens', {
        typeName: type,
      });
    },
    async trackingUrlTokens() {
      return request.get('/traffic-sources/trackingUrl');
    },
  },
  manualConnection: {
    async getAllCampaigns(trafficSourceId, trackerId, sourceTypeName, trackerTypeName) {
      return request.post('/manual-connection/get-campaigns', {
        trafficSourceId,
        trackerId,
        sourceTypeName,
        trackerTypeName,
      });
    },

    async saveLinkedCampaigns(campaigns, accounts) {
      return request.post('/manual-connection/save-campaigns', {
        campaigns,
        accounts,
      });
    },

    async deleteCampaign(payload) {
      return request.put('/manual-connection/delete-campaign', payload);
    },
  },
  manualStatsUpdate: {
    async submitForm(trafficSourceAccountIds, startDate, endDate) {
      return request.post('/campaign/manual-stats-update', {
        trafficSourceAccountIds,
        startDate,
        endDate,
      });
    },
  },
};
